<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">A<span class="small">CKNOWLEDGEMENTS</span></p>
<p class="noindent">As usual, there are so many people who have made this book possible. We are grateful to all for your assistance and expertise. Grateful thanks and praise go out to the Burrillville Historical Society; Rutland Historical Society; <i>Sam’s Good News</i> in Rutland; Putnam Public Library; Greenville Public Library; Foster Town Hall; Scituate Town Hall; everyone at the Kennebunk Inn; Ron Kolek; Ron Kolek Jr.; Christopher Balzano and Massachusetts Crossroads; Matthew Moniz of Spooky South Coast; Brian Harnois; Jason Mayoh; Christian White; Kent Spottswood; Sheila and Beth Williams; Skip Gervais at the Mill in Greenville; the good people of Portsmouth, New Hampshire; Jeff Saraceno; Carl Johnson; Blackstone Valley Tourism Council / Tour Southern New England; Tom and Sue Wood; Greg and Magin Wood; Patti Roden; Kevin Fay; High Life Ski Lodge; Hampton Historical Society; Princeton Historical Society; Mulligan’s in Biddeford; Mandy Pincins; Webster Library; the <i>Patriot</i> newspaper; the <i>Yankee Shopper</i>; Tavern on Main; Smith’s Castle; Barbara Thaeder; and all those who wished to remain anonymous but were vital in the making of this book.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?35e58ab2